import { createUseQuery } from 'api/common/createUseQuery'
import { Cluster, fetchClusters } from 'api/fetchers/fetchClusters'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useClusters = createUseQuery({
  queryKey: ApiQueryKeys.CLUSTERS,
  fetcher: fetchClusters,
  selector: res => (res?.data as Cluster[] | undefined) ?? ([] as Cluster[]),
})
